import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import cn from 'classnames';

import * as style from './style.css';

export interface IRatingTagItemProps {
  type: string;
  title: string;
  count: number;
  isSelected: boolean;
  onClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RatingTagItem: React.FC<IRatingTagItemProps> = ({ title, type, count, isSelected, onClick }) => {
  return (
    <label className={cn(style['label'], isSelected && style['active'])}>
      <input type="checkbox" name="rating-tag" id={title} value={type} onChange={onClick} />

      <div className={style['title']}>
        <UIText2 color="text-primary-default">{title}</UIText2>
        &nbsp;
        <UIText2 color="gray40_100">{count}</UIText2>
      </div>
    </label>
  );
};
